import { EventTracking } from './index';
import { decodeInsecureJwt } from '../helpers';

let EventTracker;

export const transformApiEndpointToEventName = (
  endpoint: string,
  method = 'GET',
) => {
  const apiEndPointName = endpoint
    // remove the initial /
    .substring(
      1,
      endpoint.indexOf('?') > -1 ? endpoint.indexOf('?') : endpoint.length,
    )
    // remove all ids from the URL
    .replaceAll(/[0-9a-z]{24}\/?/g, '')
    // replace all / with -
    .replaceAll('/', '_')
    // remove any commas or periods
    .replaceAll(/[,|.]/g, '')
    // trim any trailing -
    .replace(/_$/g, '');
  const apiMethod = method.toLowerCase();
  return `api.${apiMethod}.${apiEndPointName}.timer`;
};
export const getEventTracker = (orgName?: string) => {
  if (!EventTracker) {
    EventTracker = new EventTracking(orgName);
  }
  if (!EventTracker.orgName && orgName) {
    EventTracker.setOrgName(orgName);
  }
  return EventTracker;
};

export const countEvent = ({
  name,
  count = 1,
  context,
  apiKey,
}: {
  name: string;
  count?: number;
  context?: string;
  apiKey?: string;
}) => {
  const orgName = apiKey ? decodeInsecureJwt(apiKey).orgName : null;
  getEventTracker(orgName).countEvent(name, count, context);
};

export const timeEventStart = ({
  name,
  apiKey,
}: {
  name: string;
  apiKey?: string;
}) => {
  const orgName = apiKey ? decodeInsecureJwt(apiKey).orgName : null;
  getEventTracker(orgName).timeEventStart(name);
};
export const timeEventStop = ({
  name,
  context,
  apiKey,
}: {
  name: string;
  context?: string;
  apiKey?: string;
}) => {
  const orgName = apiKey ? decodeInsecureJwt(apiKey).orgName : null;
  getEventTracker(orgName).timeEventStop(name, context);
};
